"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../../");
const lodash_1 = require("lodash");
const skill_1 = require("../../skill");
class BuffSkill {
    constructor(no, name, cost, buffBuilder) {
        this.handlers = [];
        this.passive = false;
        this.target = skill_1.SkillTarget.TEAM;
        this.no = no;
        this.name = name;
        this.cost = cost;
        this.buffBuilder = buffBuilder;
    }
    use(battle, sourceId, _) {
        const source = battle.getEntity(sourceId);
        const entities = battle.getTeamEntities(source.teamId);
        entities.forEach(e => {
            let buffs = this.buffBuilder(battle, sourceId, e.entityId);
            if (!lodash_1.isArray(buffs))
                buffs = [buffs];
            lodash_1.forEach(buffs, b => battle.actionAddBuff(b, __1.Reasons.SKILL));
        });
    }
}
exports.default = BuffSkill;
